class ChannelService {
  loadScript() {
  
  // ChannelIO script included twice 에러 발생 방지 코드 추가
  if (window.ChannelIO) return;
    
  // 여기서부터 기존 코드 
    (function(){var w=window;if(w.ChannelIO){return w.console.error("ChannelIO script included twice.");}var ch=function(){ch.c(arguments);};ch.q=[];ch.c=function(args){ch.q.push(args);};w.ChannelIO=ch;function l(){if(w.ChannelIOInitialized){return;}w.ChannelIOInitialized=true;var s=document.createElement("script");s.type="text/javascript";s.async=true;s.src="https://cdn.channel.io/plugin/ch-plugin-web.js";var x=document.getElementsByTagName("script")[0];if(x.parentNode){x.parentNode.insertBefore(s,x);}}if(document.readyState==="complete"){l();}else{w.addEventListener("DOMContentLoaded",l);w.addEventListener("load",l);}})();
  }

  boot(option, callback) {
    window.ChannelIO('boot', option, callback);
  }

  shutdown() {
    window.ChannelIO('shutdown');
  }

  showMessenger() {
    window.ChannelIO('showMessenger');
  }
  
  hideMessenger() {
    window.ChannelIO('hideMessenger');
  }

  openChat(chatId, message) {
    window.ChannelIO('openChat', chatId, message);
  }

  track(eventName, eventProperty) {
    window.ChannelIO('track', eventName, eventProperty);
  }
  
  onShowMessenger(callback) {
    window.ChannelIO('onShowMessenger', callback);
  }
  
  onHideMessenger(callback) {
    window.ChannelIO('onHideMessenger', callback);
  }
  
  onBadgeChanged(callback) {
    window.ChannelIO('onBadgeChanged', callback);
  }

  onChatCreated(callback) {
    window.ChannelIO('onChatCreated', callback);
  }

  onFollowUpChanged(callback) {
    window.ChannelIO('onFollowUpChanged', callback);
  }

  onUrlClicked(callback) {
    window.ChannelIO('onUrlClicked', callback);
  }

  clearCallbacks() {
    window.ChannelIO('clearCallbacks');
  }
  
  updateUser(userInfo, callback) {
    window.ChannelIO('updateUser', userInfo, callback);
  }

  addTags(tags, callback) {
    window.ChannelIO('addTags', tags, callback);
  }

  removeTags(tags, callback) {
    window.ChannelIO('removeTags', tags, callback);
  }

  setPage(page) {
    window.ChannelIO('setPage', page);
  }

  resetPage() {
    window.ChannelIO('resetPage');
  }

  showChannelButton() {
    window.ChannelIO('showChannelButton');
  }

  hideChannelButton() {
    window.ChannelIO('hideChannelButton');
  }

  setAppearance(appearance) {
    window.ChannelIO('setAppearance', appearance);
  }
  
  // clearChannelCookies() {
  //   const cookies = document.cookie.split(";");
  //   const hostname = window.location.hostname;
  //   const domain = hostname.replace('www.', '');

  //   for (let i = 0; i < cookies.length; i++) {
  //     const cookie = cookies[i];
  //     const eqPos = cookie.indexOf("=");
  //     const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
      
  //     if (name.startsWith('ch-') || name.startsWith('x-') || name.startsWith('_ch')) {
  //       const expireStr = "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
        
  //       document.cookie = name + expireStr;
  //       document.cookie = name + expireStr + " domain=" + hostname + ";";
  //       if (hostname !== 'localhost') {
  //         document.cookie = name + expireStr + " domain=." + domain + ";";
  //         document.cookie = name + expireStr + " domain=" + domain + ";";
  //       }
  //     }
  //   }
  //   console.log("ChannelTalk cookies cleared.");
  // }

  clearChannelCookies() {
    const hostname = window.location.hostname;
    const cookies = document.cookie.split(";");

    // 1. 쿠키 청소
    cookies.forEach(cookie => {
      const name = cookie.split("=")[0].trim();
      if (name.startsWith('ch-') || name.startsWith('x-')) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${hostname}`;
      }
    });

    // 2. 스토리지 청소 (로컬, 세션)
    // const clearStorage = (storage) => {
    //   try {
    //     Object.keys(storage).forEach(key => {
    //       // 채널톡 관련 키들만 골라서 삭제
    //       if (key.startsWith('Channel.')) {
    //         storage.removeItem(key);
    //       }
    //     });
    //   } catch (e) {
    //     console.error("Storage clear error", e);
    //   }
    // };

    // clearStorage(localStorage);
    // clearStorage(sessionStorage);

    // console.log(`[${hostname}] 채널톡 모든 세션 흔적(Cookie/Local/Session) 삭제 완료`);
  }

}

export default new ChannelService();